<template>
  <section class="bk-gold-notrotate not-margin-top">
    <h2 class="title font-heading en is-4">検索条件</h2>
    <div class="search-settings">
      <div class="form">
        <div class="form-group horizon">
          <input class="font-text ja is-2" name="keyword" type="text" placeholder="検索ワード" v-on:keydown="keydown" v-model="keyword">

          <div class="select-group">
            <p class="group-title" data-toggle="group1">
              <select class="group-title" v-model="category" ref="category_select">
                <option value="0">カテゴリーで選択</option>
                <option v-for="category in categories" :key="category.id" :value="category.id">{{category.title}}</option>
              </select>
            </p>
            <div v-if="category !== 0">
              <select_categories v-if="isExistSubCategory()"
                                 :searchCategories="searchCategories"
                                 :parentCategory="selectedCategory()"
                                 :categories="subCategories()"
                                 v-on:selectCategory="selectCategory">

              </select_categories>
              <!-- option_categories :parentCategory="selectedCategory()" :categories="subCategories()" v-else ></option_categories -->
            </div>
          </div>

          <div class="select-group">

<!--
            <p class="group-title" data-toggle="group2">
              <select class="group-title" v-model="selectedMaker">
                <option value="0">メーカーブランドを選択</option>
                <option :value="maker.id" v-for="maker in makers" :key="maker.id">{{maker.name}}</option>
              </select>
            </p>

            <div class="sub-select-group" v-if="isExistsBrands()">
              <p class="group-title" data-toggle="sub-group-bike" >
                <select class="group-title" ref="category_select" v-model="selectedBrand">
                  <option value="0">- 選択 -</option>
                  <option v-for="brand in brands()" :key="brand.id" :value="brand.id">{{brand.name}}</option>
                </select>
              </p>
            </div>
-->

          </div>
          <!--
                    <div class="select-group">
                      <p class="group-title" data-toggle="group3">
                        <select class="group-title">
                          <option>その他の絞り込み条件</option>
                        </select>
                      </p>
          </div>
          -->
          <button class="square-btn font-text ja is-2 search-button" type="button" v-on:click="search" :disabled="!searchEnable">検索<i class="far fa-search p-left"></i></button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import select_categories from "components/SelectCategories";
import option_categories from "components/OptionCategories";

export default {
  name: "product_search",
  props: [ 'queryKeyword', 'queryCategoryId', 'queryMaker', 'queryBrand', 'scope'],
  components: {select_categories, option_categories},
  data() {
    return  {
      keyword: '',
      categories: [],
      category: 0,
      searchCategory: 0,
      searchCategories: [],
      makers: [],
      selectedMaker: 0,
      selectedBrand: 0,
    }
  },
  computed: {
    searchEnable() {
      return (
        this.keyword.length > 0 ||
        parseInt(this.searchCategory) > 0 ||
        parseInt(this.selectedMaker) > 0 ||
        parseInt(this.selectedBrand) > 0
      )
    }
  },
  async mounted() {
    this.keyword = this.queryKeyword
    const response = await axios('/categories.json?scope=' + this.scope)
    this.categories = response.data.categories
    this.makers = response.data.makers
    this.setCategories()
    this.setMaker()
  },
  methods: {
    keydown(event) {
      if (event.keyCode === 13) {
        console.log('key down')
        this.search()
      }
    },
    setCategories() {
      if(this.queryCategoryId.length > 0) {
        this.searchCategory = parseInt(this.queryCategoryId)
        this.searchCategories = this.getParentIds(this.searchCategory)
        if(this.searchCategories.length > 0) {
          for(let sc of this.searchCategories) {
            for (let category of this.categories) {
              if (sc === category.id) {
                this.category = sc
                break
              }
            }
          }
        }
      }
    },
    setMaker() {
      if(this.queryMaker.length > 0){
        const makers = this.makers.filter((maker) => {return maker.name === this.queryMaker})
        if(makers.length > 0) {
          this.selectedMaker = makers[0].id
          this.$nextTick(()=>{
            if(this.queryBrand.length > 0) {
              const brands = (makers[0].brands || []).filter((brand) => {return brand.name === this.queryBrand})
              if(brands.length > 0) {
                this.selectedBrand = brands[0].id
              }
            }
          });
        }
      }
    },
    selectedCategory() {
      const categories = this.categories.filter((ct) => { return this.category === ct.id})
      if (categories.length > 0) {
        return categories[0].title
      }
      else {
        return "";
      }
    },
    isExistsBrands() {
      if(parseInt(this.selectedMaker) > 0) {
        const makers = this.makers.filter((maker) => {return maker.id === parseInt(this.selectedMaker)})
        return makers.length > 0 && makers[0].brands.length > 0
      }
      else {
        return false
      }
    },
    isExistSubCategory() {
      return parseInt(this.category) > 0  && this.subCategories().length > 0
    },
    brands() {
      const makers = this.makers.filter((maker) => {return maker.id === parseInt(this.selectedMaker)})
      if(makers.length > 0) {
        return makers[0].brands || []
      }
      else {
        return []
      }
    },
    subCategories() {
      let index = 0
      for(let i = 0 ; i < this.categories.length; i ++) {
        if(this.categories[i].id === this.category) {
          index = i
          break
        }
      }
      if(index >= 0) {
        return this.categories[index].children || []
      }
      else {
        return []
      }
    },
    selectCategory(categoryId) {
      this.searchCategory = categoryId
    },
    search() {
      const params = []
      if (this.keyword.length > 0) {
        params.push('keyword=' + this.keyword)
      }
      if (parseInt(this.searchCategory) !== 0) {
        params.push("category=" + this.searchCategory)
      }
      if (parseInt(this.selectedMaker) !== 0) {
        const makers = this.makers.filter((maker) => {return maker.id === parseInt(this.selectedMaker)})
        if(makers.length > 0) {
          params.push("maker=" + makers[0].name)
          if (parseInt(this.selectedBrand) !== 0) {
            const brands = makers[0].brands.filter((brand) => {return brand.id === parseInt(this.selectedBrand)})
            if(brands.length > 0) {
              params.push("brand=" + brands[0].name)
            }
          }
        }
      }
      let url = "/products"
      if (params.length > 0) {
        url = url + '?' + params.join('&')
      }
      document.location.href = url
    },
    getParentId (categories, targetId) {
      let ret = null
      for(let category of categories) {
        if (category.id === targetId) {
          if(category.parent_id) {
            ret = category.parent_id
            break
          }
        }
        if (category.children) {
          const _ret = this.getParentId(category.children, targetId)
          if (_ret) {
            ret = _ret
            break
          }
        }
      }
      return ret
    },
    getParentIds(targetId) {
      const ids = []
      let id = targetId
      while(true) {
        let categoryId = this.getParentId(this.categories, id)
        if (categoryId == null) break
        ids.push(categoryId)
        id = categoryId
      }
      ids.push(targetId)
      return ids;
    }
  },
  watch: {
    category() {
      this.searchCategory = this.category
    },
    selectedMaker() {
      this.selectedBrand = 0
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
